(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6219],{

/***/ 38001:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]",
      function () {
        return __webpack_require__(22745);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ FaqSearchContext; },
/* harmony export */   "x": function() { return /* binding */ FaqSearchProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);


var FaqSearchContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var FaqSearchProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), searchValue = ref[0], setSearchValue = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedCategory = ref1[0], setSelectedCategory = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), selectedTag = ref2[0], setSelectedTag = ref2[1];
    var _setSearchValue = function(value) {
        setSearchValue(value);
        setSelectedTag("");
        setSelectedCategory(null);
    };
    var _setSelectedTag = function(tag) {
        setSearchValue("");
        setSelectedTag(tag);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqSearchContext.Provider, {
        value: {
            searchValue: searchValue,
            setSearchValue: _setSearchValue,
            selectedCategory: selectedCategory,
            setSelectedCategory: setSelectedCategory,
            selectedTag: selectedTag,
            setSelectedTag: _setSelectedTag
        },
        children: children
    });
};


/***/ }),

/***/ 57758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BaseSeo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59370);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52375);



var trimTrailingSlash = function(slug) {
    return slug[slug.length - 1] === "/" ? slug.slice(0, slug.length - 1) : slug;
};
var BaseSeo = function(param) {
    var title = param.title, ogTitle = param.ogTitle, description = param.description, ogDescription = param.ogDescription, path = param.path, image = param.image;
    var canonical = path ? "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O).concat(trimTrailingSlash(path)) : _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O;
    var baseTitle = _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_NAME */ .px;
    var baseDescription = "Colophon is an international, award-winning type foundry based in London (UK) and Los Angeles (US). We create, publish, and distribute high-quality retail and custom typefaces for analog and digital media.";
    var seoTitle = title || baseTitle;
    var seoDescription = description || baseDescription;
    var twitter = _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOCIAL_TWITTER_ID */ .R1 ? {
        handle: _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOCIAL_TWITTER_ID */ .R1,
        cardType: "summary_large_image"
    } : null;
    var openGraph = {
        url: canonical,
        title: ogTitle || seoTitle,
        description: ogDescription || seoDescription,
        images: [
            {
                url: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O).concat(image ? image : "/img/og.png"),
                alt: "Colophon Foundry"
            }
        ],
        site_name: "Colophon Foundry"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: seoTitle,
        description: seoDescription,
        canonical: canonical,
        twitter: twitter,
        openGraph: openGraph
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseSeo);


/***/ }),

/***/ 22745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var storyblok__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47659);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94842);
/* harmony import */ var _components_cms_FaqSearch_FaqSearchContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76846);
/* harmony import */ var _components_global_Footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6695);
/* harmony import */ var _components_global_Header__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50794);
/* harmony import */ var _components_seo_BaseSeo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57758);
/* harmony import */ var _lib_storyblok_storyblokNavLinks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83176);
/* harmony import */ var _storyblok_components_DynamicComponent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79426);









var Page = function(param) {
    var story = param.story, preview = param.preview, resolve_relations = param.resolve_relations;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var sbStory = preview ? (0,storyblok__WEBPACK_IMPORTED_MODULE_1__/* .useStoryblok */ .P)(story, preview, resolve_relations) : story;
    var globalLinks = (0,_lib_storyblok_storyblokNavLinks__WEBPACK_IMPORTED_MODULE_8__/* .getStoryBlokNavLinks */ .G)(story);
    var _content = sbStory.content, _headerTheme = _content.headerTheme, headerTheme = _headerTheme === void 0 ? "" : _headerTheme, _footerTheme = _content.footerTheme, footerTheme = _footerTheme === void 0 ? "" : _footerTheme, _SEO = _content.SEO, SEO = _SEO === void 0 ? {} : _SEO, _name = sbStory.name, name = _name === void 0 ? "" : _name, full_slug = sbStory.full_slug;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_seo_BaseSeo__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: SEO === null || SEO === void 0 ? void 0 : SEO.title,
                description: SEO === null || SEO === void 0 ? void 0 : SEO.description,
                ogDescription: SEO === null || SEO === void 0 ? void 0 : SEO.og_description,
                ogTitle: SEO === null || SEO === void 0 ? void 0 : SEO.og_title,
                image: SEO === null || SEO === void 0 ? void 0 : SEO.og_image,
                path: full_slug
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Header__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                navigation: globalLinks,
                headerTheme: headerTheme,
                pageName: name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                id: "main",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cms_FaqSearch_FaqSearchContext__WEBPACK_IMPORTED_MODULE_3__/* .FaqSearchProvider */ .x, {
                    children: sbStory && sbStory.content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storyblok_components_DynamicComponent__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        blok: sbStory.content
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Footer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                theme: footerTheme,
                navigation: globalLinks.footerLinks
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Page);
Page.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Layout */ .Ar, {
        children: page
    });
};


/***/ }),

/***/ 47659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ Storyblok; },
  "P": function() { return /* reexport */ useStoryblok; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
;// CONCATENATED MODULE: ./storyblok/hooks/useStoryblok.ts


function useStoryblok(originalStory, preview) {
    var resolve_relations = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var initEventListeners = // adds the events for updating the visual editor
    // see https://www.storyblok.com/docs/guide/essentials/visual-editor#initializing-the-storyblok-js-bridge
    function initEventListeners() {
        var StoryblokBridge = window.StoryblokBridge;
        if (typeof StoryblokBridge !== "undefined") {
            // initialize the bridge with your token
            var storyblokInstance = new StoryblokBridge({
                resolveRelations: resolve_relations
            });
            // reload on Next.js page on save or publish event in the Visual Editor
            storyblokInstance.on([
                "change",
                "published"
            ], function() {
                return location.reload();
            });
            // live update the story on input events
            storyblokInstance.on("input", function(event) {
                // check if the ids of the event and the passed story match
                if (story && event.story.content._uid === story.content._uid) {
                    // change the story content through the setStory function
                    setStory(event.story);
                }
            });
            storyblokInstance.on("enterEditmode", function(event) {
                // loading the draft version on initial enter of editor
                Storyblok.get("cdn/stories/".concat(event.storyId), {
                    resolve_relations: resolve_relations,
                    version: "draft"
                }).then(function(param) {
                    var data = param.data;
                    if (data.story) {
                        setStory(data.story);
                    }
                }).catch(function(error) {
                    console.log(error);
                });
            });
        }
    };
    var addBridge = // appends the bridge script tag to our document
    // see https://www.storyblok.com/docs/guide/essentials/visual-editor#installing-the-storyblok-js-bridge
    function addBridge(callback) {
        // check if the script is already present
        var existingScript = document.getElementById("storyblokBridge");
        if (!existingScript) {
            var script = document.createElement("script");
            script.src = "//app.storyblok.com/f/storyblok-v2-latest.js";
            script.id = "storyblokBridge";
            document.body.appendChild(script);
            script.onload = function() {
                // once the scrip is loaded, init the event listeners
                callback();
            };
        } else {
            callback();
        }
    };
    var ref = (0,react.useState)(originalStory), story = ref[0], setStory = ref[1];
    (0,react.useEffect)(function() {
        // only load inside preview mode
        if (preview) {
            // first load the bridge, then initialize the event listeners
            addBridge(initEventListeners);
        }
    }, [
        originalStory,
        preview,
        setStory
    ]); // runs the effect only once & defines effect dependencies
    return story;
}

// EXTERNAL MODULE: ./node_modules/.pnpm/storyblok-js-client@4.5.6_axios@0.21.4/node_modules/storyblok-js-client/dist/index.es.js
var index_es = __webpack_require__(78578);
;// CONCATENATED MODULE: ./storyblok/lib/storyblok.js

var STORYBOOK_API_KEY = "WygMRPInxMCOSMUw1Vt4TAtt";
var Storyblok = new index_es/* default */.Z({
    accessToken: STORYBOOK_API_KEY,
    cache: {
        clear: "auto",
        type: "memory"
    }
});

;// CONCATENATED MODULE: ./storyblok/index.ts




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7099,9370,8578,7972,9774,2888,179], function() { return __webpack_exec__(38001); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);